<template>
    <div class="article-wrapper">
        <div class="panel">
            <div class="article">
                <ul class="stats flex">
                    <li>
                        <span class="stat">{{ totalViews }}</span>
                        <span class="label">Total views</span>
                    </li>
                    <li>
                        <span class="stat">{{ totalUsers }}</span>
                        <span class="label">Unique users</span>
                    </li>
                </ul>

                <h3>Views per {{ chartType === 'daily' ? 'day' : 'hour'}}</h3>
                <chartist
                    ratio="ct-chart"
                    type="Line"
                    :data="chartData"
                    :options="chartOptions"
                >
                </chartist>

                <h3>Seen by</h3>
                <avatars :users="users" v-if="users"></avatars>
            </div>
        </div>
    </div>
</template>

<script>
    import { format, parse, fromUnixTime  } from 'date-fns';
    export default {
        props: ['post'],
        data(){
            return {
                users: [],
                chartType: 'daily',
                chartData: {
                    labels: [],
                    series: []
                },
                totalUsers: null,
                totalViews: null,
                chartOptions: {
                    height: "220px",
                    stretch: false,
                    lineSmooth: false,
                    axisX: {
                        type: this.$chartist.FixedScaleAxis,
                        divisor: 4,
                        labelInterpolationFnc: this.parseAxisValues
                    },
                    axisY: {
                        onlyInteger: true,
                        low: 0
                    }
                }
            }
        },
        mounted(){
            this.fetchAnalytics();
        },
        methods: {
            parseAxisValues(value){
                return format( new Date(value), 'dd/MM/yyyy HH:mm');
                // if(this.chartType === 'daily'){
                //     return format( new Date(value), 'dd/MM/yyyy HH:mm');
                // }else{
                //     return format( new Date(value), 'dd/MM/yyyy HH:mm');
                // }
            },
            fetchAnalytics(){
                axios.get('/api/groups/' + this.$route.params.group + "/posts/" + this.$route.params.post +  "/analytics").then((response) => {
                    //let series = response.data.chartData.series[0].map(obj => obj.x = fromUnixTime(obj.x) );
                    //this.chartData.labels = labels;
                    //this.chartOptions.axisX.ticks = response.data.chartData.labels.map(date => new Date(date) );
                    this.chartType = response.data.chartType;
                    this.chartData.series = response.data.chartData.series;

                    this.totalViews = response.data.totalViews;
                    this.totalUsers = response.data.totalUsers;
                    this.users = response.data.users;

                }, (response) => {
                    this.error = response;
                });
            },
        }
    }
</script>

<style lang="scss">
    .stats{
        list-style: none;
        padding: 0 !important;
        margin: 0 !important;

        li{
            list-style: none;
            padding: 0 !important;
            margin: 0 30px 0 0 !important;

            &:before{
                content: '' !important;
            }
        }

        span{
            display: block;
        }

        .stat{
            font-size: 42px;
            font-weight: bold;
        }
    }
</style>